/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Page dashboard translation constants
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

import { IFastActionsModalsTranslation } from '@/main/components/FastActions/types/fastActionsTypes';

export const initTranslationFastActionsModals: IFastActionsModalsTranslation = {
    accountLinkText: '',
    subscribersLinkText: '',
	createInquiry: {
        text: '',
    },
	bills: {
        text: '',
    },
	documents: {
        text: '',
    },
	advanceAccount: {
        text: '',
    },
	addPromicePayment: {
        text: '',
    },
};
